<template>
    <v-container>
        <v-row>
            <v-col>
                <h1>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn icon
                                   @click="$router.push({name: 'character', params: {characterId: character.id}})"
                                   v-on="on"
                            >
                                <v-icon x-large>mdi-chevron-left</v-icon>
                            </v-btn>
                        </template>
                        <span>Go Back</span>
                    </v-tooltip>
                    Grant Item
                </h1>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12" sm="6" lg="4" xl="3" v-for="(item, itemIndex) of items" :key="itemIndex">

                <v-card>
                    <v-card-title>#{{ item.number }} - {{ item.title }}</v-card-title>
                    <v-card-text>
                        <div>{{ item.description }}</div>
                        <div>Cost: {{ item.cost }}</div>
                        <div>Slot: {{ item.slot }}</div>
                        <div>Upon Usage: {{ item.discard_effect }}</div>
                    </v-card-text>

                    <v-divider/>

                    <v-card-actions>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn icon
                                       color="primary"
                                       @click="grantItem(item)"
                                       v-on="on"
                                >
                                    <v-icon>mdi-shopping</v-icon>
                                </v-btn>
                            </template>
                            <span>Buy Item</span>
                        </v-tooltip>
                    </v-card-actions>
                </v-card>

            </v-col>
        </v-row>
    </v-container>
</template>

<script>
  import ItemService from "../services/ItemService";
  import CharacterService from "../services/CharacterService";

  export default {
    data: () => ({
      items: [],
      character: null
    }),

    created() {
      this.viewCharacter();
      this.indexItems();
    },

    methods: {
      indexItems() {
        ItemService.indexGrantableByCharacter(this.$route.params.characterId)
          .then(response => {
            this.items = response.data.data;
          })
          .catch(err => {
            console.log(err);
          });
      },

      viewCharacter() {
        CharacterService.view(this.$route.params.characterId)
          .then(response => {
            this.character = response.data.data;
          })
          .catch(err => {
            console.log(err);
          });
      },

      grantItem(item) {
        if (confirm(`Are you sure you want to grant yourself item #${item.number}?`)) {
          CharacterService.grantItem(this.character.id, item.id)
            .then(() => {
              this.indexItems();
            })
            .catch(err => {
              console.log(err);
            });
        }
      }
    }
  };
</script>
